import { ReactNode } from 'react'

import { cn } from '@/app/utils'
import { AppButton } from '@/components/shared/button'
import { ButtonVariants } from '@/components/shared/button/ui/Button.types'

type Props = {
  text?: string
  onClick?: () => void
  type?: 'button' | 'submit' | 'reset'
  variant?: ButtonVariants
  className?: string
  loading?: boolean
  children?: ReactNode
  topContent?: ReactNode
}

export const FixedBottomDrawerButton = ({
  text,
  onClick,
  type,
  variant = 'secondary',
  className,
  loading,
  children,
  topContent
}: Props) => (
  <div className="fixed bottom-0 left-0 right-0 z-10 mb-40 md:mb-24 xxs:mb-16">
    {topContent && (
      <div className="px-40 pb-8 lg:px-24 sm:px-16">{topContent}</div>
    )}
    <hr className="mb-16 text-grey-20" />
    <div className="px-40 lg:px-24 sm:px-16">
      {children ? (
        <div className="flex gap-8">{children}</div>
      ) : (
        <AppButton
          fluid
          variant={variant}
          size="large"
          className={cn(className, 'sm:!h-44')}
          onClick={onClick}
          type={type}
          loading={loading}
        >
          {text}
        </AppButton>
      )}
    </div>
  </div>
)
